import { InvoiceBillingStatusSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const HomePageRevenueByBillingStatusSchema = oz.record(
  InvoiceBillingStatusSchema,
  oz.number(),
).openapi('HomePageRevenueByBillingStatus');

export type HomePageRevenueByBillingStatus = oz.infer<typeof HomePageRevenueByBillingStatusSchema>;